import { m } from '../lib/selectorUtils';

interface RenderCallbackProps {
  render: (props: any) => any;
}

const RenderCallback = ({ render, ...props }: RenderCallbackProps) =>
  render(props);

export default m(RenderCallback);
